(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('slideshow-hero')) {
    customElements.define('slideshow-hero', class SlideshowHero extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.count = this.slides.length;
        if (this.count <= 1) return;

        this.isFade = this.dataset.transition === 'fade';
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;
        this.speed = parseInt(this.dataset.speed, 10) || 5000;

        this.onPrev = () => { this.goTo(this.index - 1); this.restart(); };
        this.onNext = () => { this.goTo(this.index + 1); this.restart(); };

        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', this.onPrev);
        if (next) next.addEventListener('click', this.onNext);

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.goTo(parseInt(dot.dataset.index, 10));
            this.restart();
          });
        });

        this.startX = null;
        this.track.addEventListener('touchstart', (e) => { this.startX = e.touches[0].clientX; }, { passive: true });
        this.track.addEventListener('touchend', (e) => {
          if (this.startX === null) return;
          const dx = e.changedTouches[0].clientX - this.startX;
          if (Math.abs(dx) > 40) { dx < 0 ? this.onNext() : this.onPrev(); }
          this.startX = null;
        }, { passive: true });

        this.setAttribute('tabindex', '0');
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.onPrev();
          if (e.key === 'ArrowRight') this.onNext();
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        document.addEventListener('visibilitychange', () => {
          document.hidden ? this.stop() : this.start();
        });

        this.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target.closest('[data-slide]'));
          if (i > -1) { this.goTo(i); this.stop(); }
        });
        this.addEventListener('shopify:block:deselect', () => this.start());

        this.goTo(0);
        this.start();
      }

      goTo(i) {
        this.index = (i + this.count) % this.count;
        if (!this.isFade) {
          this.track.style.transform = `translateX(-${this.index * 100}%)`;
        }
        this.slides.forEach((slide, idx) => {
          const active = idx === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, idx) => {
          const active = idx === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      start() {
        if (!this.autoplay || this.timer) return;
        this.timer = setInterval(() => this.goTo(this.index + 1), this.speed);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
